import Vue from 'vue'
import Search from "./components/Search";
import List from "./components/List";
import Slider from "./components/Slider";
import MainEventBanner from "./components/MainEventBanner";
import MainTableBanner from "./components/MainTableBanner";
import MainMobileBanner from "./components/MainMobileBanner";
import MainCan from "./components/MainCan";
import MainTa from "./components/MainTa";

Vue.component('search',Search)
Vue.component('list',List)
Vue.component('slider',Slider)
Vue.component('main-event-banner',MainEventBanner)
Vue.component('main-table-banner',MainTableBanner)
Vue.component('main-mobile-banner',MainMobileBanner)
Vue.component('main-can',MainCan)
Vue.component('main-ta',MainTa)